'use strict';
import request from '@/utils/request';
class NotificationsService{
    static list(query){
        return request({
            url:'/notifications/getnotifications',
            method:'get',
            params:query
        })
    }
    
}

export default NotificationsService
